import { STATUS_COLORS } from "app/modules/dashboards/dashboard-company/components/company-truck-implements-tab/company-vehicle-list/constants";

const truckIconCache = new Map<string, google.maps.Icon>();

const escapeSvgText = (value: string) =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

export const makeTruckImplementMapIcon = (color: string = STATUS_COLORS.alertBar, licensePlate = ''): google.maps.Icon => {
  const plate = licensePlate.trim();
  const cacheKey = `${color}|${plate}`;
  const cached = truckIconCache.get(cacheKey);
  if (cached) return cached;

  const hex = color.startsWith('#') && color.length === 9 ? color.slice(0, 7) : color;

  const outerR = 22;
  const innerR = 14;
  const pad = 5;
  const circleW = (outerR + pad) * 2;

  const pillFontSize = 11;
  const pillH = 18;
  const pillW = Math.max(circleW, Math.ceil(plate.length * pillFontSize * 0.63) + 16);

  const totalW = Math.max(circleW, pillW + 4);
  const cx = totalW / 2;
  const cy = outerR + pad;

  const pillY = cy + outerR + 4;
  const pillX = (totalW - pillW) / 2;
  const totalH = pillY + pillH + 4;

  const iconSize = innerR * 1.6;
  const iconScale = iconSize / 24;
  const iconX = cx - iconSize / 2;
  const iconY = cy - iconSize / 2;
  const safePlate = escapeSvgText(plate);

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${totalW}" height="${totalH}">
    <circle cx="${cx}" cy="${cy}" r="${outerR}" fill="${hex}1A" stroke="${hex}" stroke-width="2"/>
    <circle cx="${cx}" cy="${cy}" r="${innerR}" fill="white" stroke="${hex}" stroke-width="1.5"/>
    <g transform="translate(${iconX},${iconY}) scale(${iconScale})">
      <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" fill="${hex}"/>
    </g>
    <rect x="${pillX}" y="${pillY}" width="${pillW}" height="${pillH}" rx="${pillH / 2}"
      fill="white" stroke="${hex}" stroke-width="1.5"/>
    <text x="${cx}" y="${pillY + pillH / 2 + 1}" text-anchor="middle" dominant-baseline="middle"
      font-family="Arial,sans-serif" font-size="${pillFontSize}" font-weight="700" fill="#111">${safePlate}</text>
  </svg>`;

  const icon: google.maps.Icon = {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
    scaledSize: new google.maps.Size(totalW, totalH),
    anchor: new google.maps.Point(cx, cy),
  };

  truckIconCache.set(cacheKey, icon);
  return icon;
};
